import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overview" }
const _hoisted_2 = { class: "mianview" }

import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'OverviewIndex',
  setup(__props) {

const route = useRouter();
const info_but = ref(false);
onMounted(() => {
  setTimeout(() => {
    info_but.value = false;
  }, 3000);
});

function goMain() {
  route.push({
    path: "/search",
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("view", null, [
        _createElementVNode("h1", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (goMain()))
        }, "各种有趣玩具集合")
      ])
    ])
  ]))
}
}

})